// https://react-hook-form.com/api/useform

function formHookify<T>(validateSchema: (value?: T) => Promise<any>) {
  return (...args) =>
    validateSchema(...args)
      .then(() => true)
      .catch((e) => e?.errors?.[0]);
}

export default formHookify;
